var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.index},[_c('div',{style:('text-align: '+_vm.options.data.pageCss.alignment+';padding:' + _vm.options.data.pageCss.page_css_padding + 
  ';margin:' + _vm.options.data.pageCss.page_css_margin + 
  ';border-radius:' + _vm.options.data.pageCss.page_css_radius + 
  'px;background-color:' + _vm.options.data.pageCss.textBgc+';'+_vm.options.data.pageCss.myCss)},[_c('div',{ref:"thanks",staticClass:"mapBox"},[_c('div',{staticClass:"map_container",attrs:{"id":'map_container'+_vm.index}})])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }